var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$can('adminView', 'viewResolver'))?_vm._t("adminView"):(this.$can('clientView', 'viewResolver'))?_vm._t("clientView"):(this.$can('hospitalView', 'viewResolver'))?_vm._t("hospitalView"):(this.$can('publicView', 'viewResolver'))?_vm._t("publicView"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }